import React, { memo } from 'react'
import classNames from 'classnames'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { StopsSummaryConnector } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryConnector'
import { StopSummaryItem } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryItem'
import { useStopSummaryStyles } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryStyles'
import { STOP_TYPE } from 'apps/fleet-planner/constants/loads'
import { IStop } from 'apps/fleet-planner/types'
import { getStopNumber } from 'apps/fleet-planner/utils/stops'

interface IStopsSummaryProps {
  stops: IStop[]
  compact?: boolean
  className?: string
}

export const StopsSummary = memo<IStopsSummaryProps>(
  ({ stops = [], className, compact = false }) => {
    const styles = useStopSummaryStyles({ compact })
    const classes = classNames(styles.root, className)
    const [firstStop] = stops || []
    const lastStop =
      stops.find(
        stop => stop.stopType === STOP_TYPE.dropoff && stop.stopSequence === stops.length
      ) || stops[stops.length - 1]

    const firstStopNumber = getStopNumber(firstStop, stops)
    const lastStopNumber = getStopNumber(lastStop, stops)
    const hasLoaded = !!stops.length

    return (
      <div className={classes} data-test='stops-summary'>
        {hasLoaded && (
          <>
            <StopSummaryItem stop={firstStop} stopNumber={firstStopNumber} compact={compact} />

            {/* Desktop Only */}
            <div className={styles.icon}>
              <LaneArrowIcon size='xlarge' color='coolGray5' />
            </div>

            {/* Mobile only */}
            <StopsSummaryConnector stops={stops} compact={compact} />

            <StopSummaryItem stop={lastStop} stopNumber={lastStopNumber} compact={compact} />
          </>
        )}
      </div>
    )
  }
)
